import { createStore } from "vuex";

export default createStore({
  state: {
    isTempAdmin: false,
    isAdmin: sessionStorage.getItem("utype") === "99", // utype이 99일 때만 관리자로 설정
  },
  getters: {
    isTempAdmin: (state) => state.isAdmin,
    isAdmin: (state) => state.isAdmin,
  },
  mutations: {
    setTempAdmin(state, status) {
      state.isAdmin = status;
    },
    setAdmin(state, value) {
      state.isAdmin = value;
    },
  },
  actions: {
    loginAsAdmin({ commit }, userData) {
      sessionStorage.setItem("utype", userData.utype);
      commit("setAdmin", userData.utype === "99");
    },
    logout({ commit }) {
      sessionStorage.removeItem("userData");
      sessionStorage.removeItem("utype");
      commit("setAdmin", false);
    },
  },
  modules: {},
});
